{
  "AirPods Max": "AirPods Max",
  "iPhone 17 Pro": "iPhone 17 Pro",
  "Model S": "Model S",
  "Union Square": "联合广场",
  "development": "本地预览",
  "production": "正式环境",
  "test": "测试环境",
  "paid": "已付款",
  "Binance-Peg USDT": "币安锚定 USDT",
  "Wrapped BNB": "封装 BNB",
  "“Reserved” is not “Delivered”.": "“已预留”不等于“已到账”。",
  "Private submitted receipt": "已提交的私密小票",
  "Failed to fetch": "网络请求失败，请检查连接后重试。",
  "NetworkError when attempting to fetch resource.": "网络请求失败，请检查连接后重试。",
  "Network request failed": "网络请求失败，请检查连接后重试。",
  "Load failed": "加载失败，请检查连接后重试。",
  "left": "后到期",
  "No transaction was sent.": "未发送交易。",
  "A fixed purchase route and verified quotation client are not configured.": "尚未配置固定采购路线及经过验证的报价服务。",
  "Dollar budgets remain reserved accounting entries. Allocation records actual purchased token inventory; it is not a paid reward.": "美元预算仍作为预留账目保留。分配记录的是实际采购的代币库存，并不代表奖励已付款。",
  "Balances may change after this block.": "余额可能在此区块后变化。",
  "No recovery action is enabled.": "恢复操作尚未启用。",
  "This is not yet a verified reservation.": "此预留尚未通过核验。",
  "Budget release is not yet verified.": "预算释放尚未通过核验。",
  "Its current outcome still needs verification.": "当前结果仍需核验。",
  "Delivery is awaiting server verification.": "到账情况正在等待服务器核验。",
  "Its administrator can upgrade trading logic after this check. The order remains bound to this exchange address.": "管理员仍可在检查后升级交易逻辑，此订单持续绑定当前交易合约地址。",
  "This is not proof of a purchase or payout.": "这不是采购或付款证明。",
  "This step did not broadcast a transaction or submit an order.": "此步骤未广播交易或提交订单。",
  "No stock or other asset has been delivered by this submission.": "此次提交未发放股票代币或其他资产。",
  "This opens a separate transaction request in your wallet and requires gas. Nothing is marked delivered until the server verifies the onchain result.": "这会在钱包中打开独立交易请求，并消耗网络费。服务器核验链上结果前，不会标记为已到账。",
  "Awaiting transaction verification.": "等待交易核验。",
  "AppleCare+": "AppleCare+",
  "View": "查看",
  "details": "详情",
  "receipt": "张小票",
  "Receipt": "小票",
  "RECEIPT": "收据",
  "token": "枚代币",
  "TOTAL": "合计",
  "MATCHING": "正在匹配",
  "SAMPLE": "示例",
  "MINIMUM": "最低持仓",
  "RECHECKED": "重新核验",
  "kept": "小票",
  "pocket": "口袋里",
  "Same": "同样金额",
  "SH": "股",
  "in": "对应",
  "for": "对应",
  "of": "/",
  "selected": "已选择",
  "example": "示例",
  "brands": "个品牌",
  "tokens": "枚代币",
  "days": "天",
  "minutes": "分钟",
  "seconds": "秒",
  "decimals": "位精度",
  "confirmations": "个确认",
  "matched": "全额匹配",
  "bonus": "额外奖励",
  "Last check": "上次核验",
  "Food & drink": "餐饮",
  "Subscriptions": "订阅",
  "Travel": "出行",
  "Starbucks": "星巴克",
  "Nike": "耐克",
  "Walmart": "沃尔玛",
  "Sam’s Club": "山姆会员商店",
  "McDonald's": "麦当劳",
  "McDonald’s": "麦当劳",
  "Chipotle": "奇波雷墨西哥烧烤",
  "Netflix": "奈飞",
  "Spotify": "声田音乐",
  "Uber Eats": "优食外卖",
  "Uber": "优步",
  "Airbnb": "爱彼迎",
  "Disney+": "迪士尼+",
  "Microsoft": "微软",
  "Alibaba": "阿里巴巴",
  "AliExpress": "速卖通",
  "JD.com": "京东",
  "Tesla": "特斯拉",
  "Direct Apple store or Apple-billed receipts.": "苹果直营店或由苹果直接开具的小票。",
  "Amazon or Whole Foods shown as merchant; third-party seller-only invoices need review.": "商户显示为亚马逊或全食超市；仅由第三方卖家开具的票据需要复核。",
  "Direct Costco receipts.": "由开市客直接开具的小票。",
  "Direct GameStop receipts.": "由游戏驿站直接开具的小票。",
  "Starbucks-branded USD receipts; licensed locations need operator review.": "带有星巴克品牌的美元小票，授权门店需由操作员复核。",
  "McDonald’s-branded USD receipts; franchise locations need operator review.": "带有麦当劳品牌的美元小票，加盟门店需由操作员复核。",
  "Direct Nike store or Nike-billed receipts; product names in other stores do not qualify as Nike merchants.": "耐克直营店或由耐克开具的小票；其他商店小票中的耐克商品名不代表消费商户是耐克。",
  "Walmart or Sam’s Club shown as merchant.": "小票商户显示为沃尔玛或山姆会员商店。",
  "Direct Chipotle receipts.": "由奇波雷墨西哥烧烤直接开具的小票。",
  "Subscriptions billed directly by Netflix; app-store billing needs review.": "由奈飞直接收费的订阅；应用商店代收需复核。",
  "Subscriptions billed directly by Spotify; third-party billing needs review.": "由声田音乐直接收费的订阅；第三方代收需复核。",
  "Trip receipts issued by Uber; restaurant bills and Uber Eats require a separate matching rule.": "由优步开具的行程小票；餐厅账单及优食外卖需要单独的匹配规则。",
  "Airbnb platform payment receipts; a host-only invoice is not enough.": "爱彼迎平台付款凭据，仅房东开具的发票不足以通过匹配。",
  "Subscriptions billed directly by Disney+; third-party billing, merchandise and park tickets are not included.": "由迪士尼+直接收费的订阅；不包含第三方代收、商品和乐园门票。",
  "Subscriptions billed directly by Adobe.": "由 Adobe 直接收费的订阅。",
  "Microsoft-billed purchases or subscriptions; Xbox product names on another retailer’s receipt do not establish Microsoft as the merchant.": "由微软收费的购物或订阅；其他零售商小票中的 Xbox 商品名不代表商户是微软。",
  "Alibaba or AliExpress platform payment receipts in USD; third-party seller-only invoices need review.": "阿里巴巴或速卖通平台的美元付款凭据；仅第三方卖家开具的发票需复核。",
  "JD.com-issued USD receipts; unsupported currencies and third-party seller-only invoices need review.": "京东开具的美元小票；不支持的币种及仅第三方卖家开具的票据需复核。",
  "Scan any receipt and preview a receipt reward. Costco and Apple examples are illustrative; no stock delivery is configured. BSC EDITION.": "扫描小票，查看奖励示例。开市客和苹果仅为示意。",
  "Scan any receipt and preview a receipt reward. Costco and Apple examples are illustrative; no stock delivery is configured.": "扫描小票，查看奖励示例。开市客和苹果仅为示意。",
  "Buy the product. Preview the reward.": "日常消费，遇见奖励。",
  "Preview receipt rewards in this local BSC build. No stock delivery is configured.": "查看本地 BSC 版本的小票奖励示例。",
  "RECEIPT · BSC edition": "收据 · BSC 版本",
  "prepared": "已准备",
  "pending": "待确认",
  "confirming": "确认中",
  "confirmed": "已确认",
  "reverted": "已回滚",
  "mismatch": "信息不符",
  "unavailable": "暂不可用",
  "signature rejected": "签名已取消",
  "awaiting wallet": "等待钱包",
  "transfer": "转账",
  "swap": "兑换",
  "approval": "授权",
  "checking": "核验中",
  "verified": "已验证",
  "unverified": "未验证",
  "disputed": "存在争议",
  "open": "进行中",
  "cancelled": "已取消",
  "filled": "已成交",
  "sending": "发送中",
  "accepted": "已接收",
  "uncertain": "结果待确认",
  "default": "默认",
  "Width": "宽度",
  "Height": "高度",
  "Contrast": "对比度",
  "Sharpness": "清晰度",
  "Confidence": "置信度",
  "Enabled": "已启用",
  "Disabled": "未启用",
  "Version": "版本",
  "Mode": "模式",
  "Type": "类型",
  "Valid": "有效",
  "Created at": "创建时间",
  "Updated at": "更新时间",
  "Proves authenticity": "能否证明真实性",
  "Minimum balance": "最低余额",
  "Capture source": "拍摄来源",
  "Local policy approved": "已通过本地规则核验",
  "Multiple subtotals": "发现多个小计",
  "Adjustment unreadable": "无法识别调整金额",
  "Line item unreadable": "无法识别商品明细",
  "Line items or subtotal missing": "缺少商品明细或小计",
  "Line items subtotal mismatch": "明细金额与小计不符",
  "Total arithmetic mismatch": "总额计算不符",
  "Conflicting totals": "总额存在冲突",
  "Auto ocr confidence low": "自动文字识别置信度不足",
  "Image quality review required": "图片质量需要复核",
  "Usd not explicit": "缺少明确的美元标记",
  "Payment evidence missing": "缺少付款依据",
  "Invoice id required": "需要小票编号",
  "Receipt date limit": "小票日期超出范围",
  "Conflicting dates": "日期存在冲突",
  "Receipt total limit": "小票总额超出限制",
  "Document risk indicator": "票据出现风险标记",
  "Ai hint requires review": "图像辅助结果需要复核",
  "Duplicate invoice id": "小票编号重复",
  "Duplicate fingerprint missing": "缺少去重指纹",
  "Duplicate screen capacity review": "去重检查超出容量，需要复核",
  "Similar receipt image": "发现相似小票图片",
  "Manual authenticity review required": "需要人工复核真实性",
  "CNY_SETTLEMENT_NOT_ENABLED": "人民币原金额已保留，待人工核查奖励",
  "Cny settlement not enabled": "人民币奖励换算尚未启用",
  "Chinese yuan was recognized. A reviewed CNY-to-USD conversion is required before reserving any reward.": "已识别人民币。预留任何奖励前，必须先完成经过核验的人民币兑美元换算。",
  "CURRENCY_AMBIGUOUS": "币种信息存在冲突",
  "Currency ambiguous": "币种信息存在冲突",
  "BLURRY": "图片模糊",
  "CROPPED": "小票不完整",
  "MISSING_MERCHANT": "缺少商户",
  "MISSING_DATE": "缺少日期",
  "MISSING_TOTAL": "缺少总额",
  "MISSING_PAYMENT": "缺少付款行",
  "AMOUNT_CONFLICT": "金额存在冲突",
  "DATE_CONFLICT": "日期存在冲突",
  "POSSIBLE_EDIT": "疑似修改，需要复核",
  "NOT_RECEIPT": "可能不是小票",
  "REFUND_OR_VOID": "退款或作废提示",
  "PROMPT_INJECTION": "票据含有试图干预审核的指令",
  "UNSUPPORTED_CURRENCY": "奖励结算暂不支持此币种",
  "UNCERTAIN": "识别结果存在不确定性",
  "PDD Holdings": "拼多多",
  "PDD HOLDINGS": "拼多多",
  "No additional first-receipt matching.": "无首单额外匹配。",
  "RECEIPT_QUEUED": "小票已收到，处理中",
  "AWAITING_MANUAL_REVIEW": "等待审核",
  "HOURLY_CLAIM_QUEUE": "奖励处理中，请稍后查看",
  "HOURLY_REWARD_QUEUE": "奖励处理中，请稍后查看",
  "OCR_OR_ANALYSIS_UNAVAILABLE": "原图已保留，等待复核",
  "DUPLICATE_IMAGE_RECORDED": "重复提交已记录",
  "maxApprovalsPerHour": "常规每小时批准笔数",
  "maxClaimsPerHour": "常规每小时发放笔数",
  "Receipt BSC": "收据",
  "Private original receipt for manual review": "供人工审核的私密小票原图"
}
